// We want to walk through a complex data structure and call a transform on every part of it.
// Note: that the transform gets called on EVERYTHING, so you need to be careful what the transform operates on.
// For and example see the spec file.
const transformWalk = (target, transform) => {
    if (!target || ['string', 'boolean', 'number'].includes(typeof target))
        return transform(target);
    if (Array.isArray(target)) {
        return transform(target.map((subTarget) => transformWalk(subTarget, transform)));
    }
    if (typeof target === 'object') {
        return transform(Object.entries(target).reduce((newObj, [key, value]) => (Object.assign(Object.assign({}, newObj), { [key]: transformWalk(value, transform) })), {}));
    }
};
export default transformWalk;
//# sourceMappingURL=transform-walk.js.map